module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "dark": "",
      "background-color": "blue",
      "slider-color": "white"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    attrs: {
      "ripple": "",
      "router": "",
      "exact": "",
      "to": ("/parcelnumbercontainers/" + (_vm.$route.params.id) + "/tabs/container")
    }
  }, [_vm._v("Container")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "ripple": "",
      "router": "",
      "exact": "",
      "to": ("/parcelnumbercontainers/" + (_vm.$route.params.id) + "/tabs/parcelnumberranges")
    }
  }, [_vm._v("Number Ranges")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "ripple": "",
      "router": "",
      "exact": "",
      "to": ("/parcelnumbercontainers/" + (_vm.$route.params.id) + "/tabs/parcelnumberportals")
    }
  }, [_vm._v("Portals")])], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-0a2933d0"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/GetParcelNumberContainerTabs.vue
// module id = 918
// module chunks = 1